<template>
  <v-dialog width="100%" v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title
        >{{ title }} <v-spacer />
        <v-btn icon flat @click="closeDialog"><v-icon icon="$close" /></v-btn>
      </v-card-title>
      <v-card-text>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-list style="height: 400px; overflow-y: auto">
          <v-list-group
            v-for="item in categories"
            :key="item.id"
            :title="item.name"
          >
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" :title="props.name">
                <template v-slot:prepend="">
                  <v-list-tile-action start>
                    <v-checkbox-btn
                      v-model="item.checked"
                      @click.stop="selectAll(item)"
                      :indeterminate="getIndeterminate(item)"
                    />
                  </v-list-tile-action>
                </template>
              </v-list-item>
            </template>
            <v-list-item
              v-for="subItem in item.categories"
              :key="subItem.id"
              :title="subItem.name"
            >
              <template v-slot:prepend="">
                <v-list-tile-action start>
                  <v-checkbox-btn
                    v-model="subItem.checked"
                    @mouseup="updateCheckedParent(item)"
                  ></v-checkbox-btn>
                </v-list-tile-action>
              </template>
            </v-list-item>
          </v-list-group>
        </v-list>
        <v-btn color="primary" @click="saveCategories">Сохранить</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SuppliersApiRepository = RepositoryFactory.get("supplierApi");
export default {
  data() {
    return {
      show: false,
      categories: [],
      selectedColumns: [],
      loading: false,
      supplerId: 0,
      title: "Категории поставщика",
    };
  },
  methods: {
    async open(id) {
      this.supplerId = id;
      this.show = true;
      this.loading = true;
      this.categories = [];
      const result = await SuppliersApiRepository.getApiCategories(id);
      if (result) {
        this.categories = result.data;
      }
      this.loading = false;
    },
    selectAll(item) {
      item.categories.forEach((element) => {
        element.checked = !item.checked;
      });
    },
    updateCheckedParent(item) {
      setTimeout(function () {
        if (
          item.categories.length ===
          item.categories.filter((i) => i.checked).length
        ) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      }, 100);
    },
    getIndeterminate(item) {
      return (
        item.categories.length !==
          item.categories.filter((i) => i.checked).length &&
        item.categories.filter((i) => i.checked).length > 0
      );
    },
    async saveCategories() {
      await SuppliersApiRepository.saveCategoriesByApi(
        this.categories,
        this.supplerId
      );
      this.$emit("update");
    },
    closeDialog() {
      this.show = false;
      this.categories = [];
    },
  },
};
</script>
<style scoped>
.v-card-title {
  padding: 0 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: center !important;
}
</style>
